'use client'

import { Button, html } from '@ensemble.music/ui'
import { AnimatePresence, motion } from 'motion/react'
import { useEffect, useState } from 'react'

/**
 * Mobile only (the .landing-sticky-cta rule hides it above the tablet breakpoint): the bar slides
 * up once the hero has scrolled away, and hides again while the modal is open or the final CTA
 * band is on screen - it must never compete with the thing it points at. Safe-area inset comes
 * from the CSS rule.
 */
export function StickyMobileCta({
  heroId,
  finalCtaId,
  hidden,
  onStart,
}: {
  heroId: string
  finalCtaId: string
  /** True while the request modal is open. */
  hidden: boolean
  onStart: () => void
}) {
  const [past, setPast] = useState(false)

  useEffect(() => {
    const hero = document.getElementById(heroId)
    const finalCta = document.getElementById(finalCtaId)
    if (!hero || !finalCta) return

    const state = { heroGone: false, finalVisible: false }
    const update = () => setPast(state.heroGone && !state.finalVisible)

    const heroObserver = new IntersectionObserver(([entry]) => {
      state.heroGone = entry !== undefined && !entry.isIntersecting
      update()
    })
    const finalObserver = new IntersectionObserver(([entry]) => {
      state.finalVisible = entry?.isIntersecting ?? false
      update()
    })
    heroObserver.observe(hero)
    finalObserver.observe(finalCta)
    return () => {
      heroObserver.disconnect()
      finalObserver.disconnect()
    }
  }, [heroId, finalCtaId])

  return (
    <AnimatePresence>
      {past && !hidden ? (
        <motion.div
          className="landing-sticky-cta"
          initial={{ y: 96 }}
          animate={{ y: 0 }}
          exit={{ y: 96 }}
          transition={{ duration: 0.2, ease: 'easeOut' }}
        >
          <html.div className="flex flex-col w-full bg-background border-t border-border-color p-3">
            <Button
              type="button"
              size="lg"
              onClick={onStart}
            >
              Anfrage starten
            </Button>
          </html.div>
        </motion.div>
      ) : null}
    </AnimatePresence>
  )
}
